// import 'slick-carousel/slick/slick.min';

const set_table_items_height = ($table) => {
    // console.log($table);
        // function setTableItemsHeight($table) {
            $table.find('.dual-table-item').css('minHeight', '');
            let $leftColumnItems = $table.find('.dual-table-column.left .dual-table-item');
            let $rightColumnItems = $table.find('.dual-table-column.right .dual-table-item');
            let itemAmount = $leftColumnItems.length;

            for ( let i = 0; i < itemAmount; i++ ) {
                let $leftElement = $leftColumnItems.eq(i);
                let leftElementHeight = $leftElement.outerHeight();
                let $rightElement = $rightColumnItems.eq(i);
                let rightElementHeight = $rightElement.outerHeight();

                if (leftElementHeight !== rightElementHeight) {
                    if (leftElementHeight > rightElementHeight) {
                        $rightElement.css('minHeight', leftElementHeight);
                    } else {
                        $leftElement.css('minHeight', rightElementHeight);
                    }
                }
            }
        // }

}

export default set_table_items_height;